import cookie from './de/cookie';
import header from './de/header';
import footer from './de/footer';
import form from './de/form';

import common from './de/consent/common.json';
import rodo from './de/consent/rodo.json';
import data from './de/consent/data.json';
import marketing from './de/consent/marketing.json';

import home from './de/home';
import threats from './de/threats';
import offer from './de/offer';
import contact from './de/contact';
import ebook from './de/ebook';
import privacy from './de/privacy';
import legal from './de/legal';
import modals from './de/modals';
import webinar from './de/webinar';
import about from './de/about';
import estimation from './de/estimation';

export default {
    cookie,
    header,
    footer,
    form,
    consent: {
        common,
        rodo,
        data,
        marketing
    },
    home,
    threats,
    offer,
    contact,
    ebook,
    privacy,
    legal,
    modals,
    webinar,
    about,
    estimation
};



// WEBPACK FOOTER //
// ./src/i18n/de.js